import { createDefaultQueryClient } from "@marekl/adminer/api";

// Any mutation that rejects without handling its own error surfaces a toast.
// Mutations that render their own inline/field errors opt out with
// `meta: { suppressErrorToast: true }` on their useMutation definition.
//
// No `onUnauthorized` here: 401 handling lives on the single client
// (`lib/api.ts`), which backs both the auth adapter and the REST data calls.
export const queryClient = createDefaultQueryClient({
  notifyMutationErrors: true,
});
